module.exports = __webpack_public_path__ + "static/media/11.9a10c202.jpg";